export function buildInsertPositionOptions(levels) {
    // Caller should pass levels already ordered desc (GET /api/ranking_levels?order_direction=desc).
    const sorted = levels.filter(level => level.active !== false);
    if (sorted.length === 0) {
        return [{
                value: 'bottom',
                label: '最初のランク（最低位）'
            }];
    }
    const options = [{
            value: 'top',
            label: `${sorted[0].code} より上（最高位）`
        }];
    for (let i = 0; i < sorted.length - 1; i += 1) {
        const higher = sorted[i];
        const lower = sorted[i + 1];
        options.push({
            value: `after:${lower.id}`,
            label: `${higher.code} と ${lower.code} の間`
        });
    }
    options.push({
        value: 'bottom',
        label: `${sorted[sorted.length - 1].code} より下（最低位）`
    });
    return options;
}
export function defaultInsertPositionValue(levels) {
    var _a;
    const options = buildInsertPositionOptions(levels);
    const bottom = options.find(option => option.value === 'bottom');
    return (_a = bottom === null || bottom === void 0 ? void 0 : bottom.value) !== null && _a !== void 0 ? _a : options[0].value;
}
